'use strict'

import CustomerList from '@/pages/Customer/CustomerList.vue'
import Customer from '@/pages/Customer/Customer.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/customers',
    name: 'Customers',
    component: CustomerList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/:site/customers/:id',
    name: 'customer',
    component: Customer,
    beforeEnter: ifAuthenticated,
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/customer.js